/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'components/Link';
import { JiraButton, JiraLinks } from 'components/Jira';
import { cx } from '@linaria/core';
import { PageWrapperStyles } from 'components/PageWrapper/styles';
import { homePageFooterBorder, homePageFooterLink, homePageFooterLinks, homePageFooterWrapper } from '../HomePageLayout.styles';

// TODO: ADD THE LINKS BEFORE PUSHING TO MASTER
export function HomePageFooter({ footerClassName }: { footerClassName?: string }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={cx(homePageFooterBorder)}>
      <div className={cx(PageWrapperStyles.contentHorizontalPlacement, homePageFooterWrapper, footerClassName)}>
        <div className="legal">
          <span className="clarifai"> &copy; {currentYear} Clarifai. All rights reserved.</span>
          <span className="recaptcha">
            This site is protected by reCAPTCHA and the Google{' '}
            <a target="_blank" rel="noreferrer" className={homePageFooterLink} href="https://policies.google.com/privacy">
              Privacy Policy
            </a>
            {` and `}
            <a target="_blank" rel="noreferrer" className={homePageFooterLink} href="https://policies.google.com/terms">
              Terms of Service
            </a>
            {` apply.`}
          </span>
        </div>
        <ul className={homePageFooterLinks}>
          <li>
            <Link rel="noreferrer" target="_blank" href="https://docs.clarifai.com/" className={homePageFooterLink}>
              Clarifai Docs
            </Link>
          </li>
          <li>
            <JiraButton collectorId={JiraLinks.bugReport.collectorId} clickTargetSelector={JiraLinks.bugReport.clickTargetSelector}>
              <a className={homePageFooterLink} role="button" tabIndex={0}>
                Report An Issue
              </a>
            </JiraButton>
          </li>
          <li>
            <JiraButton collectorId={JiraLinks.sendFeedback.collectorId} clickTargetSelector={JiraLinks.sendFeedback.clickTargetSelector}>
              <a className={homePageFooterLink} role="button" tabIndex={0}>
                Product Feedback
              </a>
            </JiraButton>
          </li>
          <li>
            <Link rel="noreferrer" target="_blank" href="https://status.clarifai.com/" className={homePageFooterLink}>
              System Status
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  );
}
